var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 0H3.75C1.67893 0 0 1.67893 0 3.75V26.25C0 28.3211 1.67893 30 3.75 30H26.25C28.3211 30 30 28.3211 30 26.25V3.75C30 1.67893 28.3211 0 26.25 0Z",
    fill: "#D2E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 14.0625C11.9638 14.0625 14.0625 11.9638 14.0625 9.375C14.0625 6.78617 11.9638 4.6875 9.375 4.6875C6.78617 4.6875 4.6875 6.78617 4.6875 9.375C4.6875 11.9638 6.78617 14.0625 9.375 14.0625Z",
    fill: "#4294FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26.25V15.5493L25.9753 11.5247C25.8851 11.4342 25.7773 11.3632 25.6586 11.3159C25.5399 11.2687 25.4127 11.2463 25.285 11.25C25.1573 11.2538 25.0317 11.2837 24.916 11.3378C24.8002 11.392 24.6968 11.4693 24.6121 11.5649L17.1121 20.0024C16.9531 20.181 16.8684 20.4136 16.8754 20.6526C16.8824 20.8916 16.9805 21.1188 17.1496 21.2878L25.8618 30H26.25C27.2443 29.9991 28.1975 29.6037 28.9006 28.9006C29.6036 28.1976 29.999 27.2443 30 26.25Z",
    fill: "#376CFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7255 16.2122C14.6353 16.1185 14.5257 16.0454 14.4045 15.9982C14.2833 15.9509 14.1532 15.9305 14.0233 15.9384C13.8938 15.9438 13.7667 15.9761 13.6503 16.0331C13.5338 16.0901 13.4304 16.1708 13.3467 16.2698L2.07715 29.5883C2.59473 29.8551 3.16792 29.9962 3.75021 30H26.2502C26.877 29.9957 27.4924 29.8324 28.0389 29.5254L14.7255 16.2122Z",
    fill: "#4294FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.82e218af13cc25f975a082c6e918882d.svg";
export { ForwardRef as ReactComponent };